import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ListAppointmentsWidget } from '@frontend/schedule';
import { ContactDetails } from '../../../contact-details/contact-details';
import { CustomerDetailsProps } from '../../customer-details';
import { AppointmentInformationV2 } from './appointment-information-v2';

type AppointmentSectionContainerProps = {
  showAppointmentStatus: boolean;
  hasRecallIntegration: boolean;
};

export const AppointmentSectionContainer = ({
  data,
  locationId,
  showAppointmentStatus,
  hasRecallIntegration,
}: CustomerDetailsProps & AppointmentSectionContainerProps) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  if (!data) return null;

  if (isScheduleV3FlagEnabled) {
    return (
      <ContactDetails>
        <ListAppointmentsWidget person={data} personLocationId={locationId || ''} />
      </ContactDetails>
    );
  }

  if (!isScheduleV3FlagEnabled && showAppointmentStatus) {
    return (
      <ContactDetails>
        <AppointmentInformationV2
          data={data}
          hasRecallIntegration={!!hasRecallIntegration}
          locationId={locationId || ''}
        />
      </ContactDetails>
    );
  }

  return null;
};
